import { BaseListFilters } from "./Hooks/UseListPageFilters";

export interface BaseListResult {
  sectionItems: {
    items?: any[];
    sectionHeading?: string;
  };
  totalPages: number;
  totalItems?: number;
  error?: boolean;
  message?: string;
}
export default abstract class BaseSearchClient {
  private _endpoint?: string;
  private _language?: string;
  private _pageId?: number;
  protected _baseUrl?: string;

  constructor(
    endpoint?: string,
    language?: string,
    pageId?: number,
    baseUrl?: string,
  ) {
    this._endpoint = endpoint;
    this._language = language;
    this._pageId = pageId;
    this._baseUrl = baseUrl;
  }

  // Protected getter for subclass access
  protected get endpoint(): string | null {
    return this._endpoint ?? null;
  }

  protected get language(): string | null {
    return this._language ?? null;
  }

  protected get pageId(): number | null {
    return this._pageId ?? null;
  }

  // Guaranteed methods that are specific to each subclass
  abstract GetItems({ ...params }: BaseListFilters): Promise<BaseListResult>;
  abstract GetParams(): any;
  abstract BuildUrlFromProps(...params: any): string | undefined;
}
